interface DelugeProtocol {
  templates: {
    [templateUid: string]: {
      name: string;
      extra_info: {
        preset?: boolean;
        src_template?: string;
      };
    };
  };
}

// Returns null if user cancels the file selection
export async function isUserInputRequiredForPresetOveride(
  schema: Object,
  deluge: DelugeProtocol
): Promise<boolean> {
  if (!('presets' in schema)) {
    return false;
  }
  const presets = schema.presets as string[];
  const presetDisplayNames = Object.keys(presets).map(
    (key) => presets[key]['display_name']
  );
  const delugePresets = Object.values(deluge.templates).filter(
    (template) =>
      template.extra_info.preset &&
      presetDisplayNames.includes(template.display_name)
  );
  if (delugePresets.length === 0) {
    return false;
  }
  return delugePresets;
}
